import React from "react";
import FromBase from './Base/Base'
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
class From extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasTap:props.hasTap!=null&&props.hasTap!=undefined?props.hasTap:true,
            formBase:props.formBase,
            hasSearch:props.hasSearch!=null&&props.hasSearch!=undefined?props.hasSearch:true,
            isFull:props.isFull!=null&&props.isFull!=undefined?props.isFull:false,
            id:props.id!=null&&props.id!=undefined?props.id:'new',
            isChange:props.isChange!=null&&props.isChange!=undefined?props.isChange:'new',
        }
    }

    render() {
        const {formBase,hasTap,hasSearch,isFull,id,isChange} = this.state
        return (
            <div>
                <FromBase hasSearch={hasSearch} isChange={isChange} isFull={isFull} id={id} hasTap={hasTap} formBase={formBase}/>
            </div>
        )
    }
}



export default From
